import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.HTMLAttributes<HTMLDivElement> & {
  ref?: React.Ref<HTMLDivElement>;
};

export const TabList: React.FC<IProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div role="tablist" className={tabLisStyle.cls({ className })} {...props}>
      {/* `role="presentation"` keeps this layout wrapper out of the accessibility
          tree so the tabs are exposed as direct children of the tablist. */}
      <div className="flex" role="presentation">
        {children}
      </div>
    </div>
  );
};

const tabLisStyle = tsv({ base: "fs-tab-group" });
